import styled from 'styled-components';

const FocusedSkuDialogWrapper = styled.div`
  .filter-dropdown-card {
    top: -365px;
  }
`;

export default FocusedSkuDialogWrapper;
